<template>
  <div class="secondary-background card px-4 py-4 ml-auto">
    <div>
      <h4 class="mr-1">Next estimated bill:</h4>
      <tooltip :text="tootltipText" />
    </div>
    <h1 class="mt-2 bill__amount">
      {{ currency + currentEstimatedBill }}
    </h1>

    <p class="font12 expire__date mb-0">on {{ expireDate }}</p>
  </div>
</template>
<script>
import Tooltip from '@/components/Common/Tooltip';
export default {
  name: 'NextEstimationCard',
  components: { Tooltip },
  props: ['currentEstimatedBill', 'currency'],
  data() {
    return {
      tootltipText: 'Your esitmated cost for the current month'
    };
  },
  computed: {
    expireDate() {
      let date = this.subscriptions?.subscription?.nextAssessmentAt;
      return this.getDateAndMonthAndYear(date) || '';
    }
  }
};
</script>
<style scoped>
.card h4 {
  display: inline-block;
}
.expire__date {
  font-weight: 500;
}
.bill__amount {
  font-size: 36px;
}
</style>
